import {postData} from "../../../../../api/componentAPIs"
import appConstants from "../../../../../appConstants";

export const assignPickup = ({ pickupIds, driverId, terminalCode, glEventHub }) => {
  const requestObj = {
    terminalCode: terminalCode,
    assignPickupDetails: pickupIds.map((pickupId) => ({ pickupId, driverId })),
  };
  glEventHub?.emit("DispatchEvents", "ShowLoaderDialog", [
    {
      label: "Pickup assignment",
      eventName: appConstants.PICKUP_EVENTS.ASSIGN_PICKUP,
      pickupIds: pickupIds,
    },
  ]);
  return postData("AssignPickup", requestObj).then(handleResponse(glEventHub));
};

export const unassignPickup = ({ pickupIds, driverId, terminalCode, glEventHub }) => {
  const requestObj = {
    terminalCode: terminalCode,
    assignPickupDetails: pickupIds.map((pickupId) => ({ pickupId, driverId })),
  };
  glEventHub?.emit("DispatchEvents", "ShowLoaderDialog", [
    {
      label: "Pickup unassignment",
      eventName: appConstants.PICKUP_EVENTS.UNASSIGN_PICKUP,
      pickupIds: pickupIds,
    },
  ]);
  return postData("UnassignPickup", requestObj).then(handleResponse(glEventHub));
};

export const reassignPickup = ({ pickupDetails, terminalCode, glEventHub }) => {
  const requestObj = {
    terminalCode: terminalCode,
    reassignPickupDetail: pickupDetails,
  };

  glEventHub?.emit("DispatchEvents", "ShowLoaderDialog", [
    {
      label: "Pickup reassignment",
      eventName: appConstants.PICKUP_EVENTS.ASSIGN_PICKUP,
      pickupIds: requestObj.reassignPickupDetail.map(
        (pickup) => pickup.pickupId
      ),
    },
  ]);

  return postData("ReassignPickup", requestObj).then(handleResponse(glEventHub));
};

const handleResponse = (glEventHub) => (response) => {
  if (Math.trunc(response?.status/100) !== 2) {
    glEventHub?.emit("DispatchEvents", "HideLoaderDialog", []);
    throw new Error(response?.message)
  }
  return response;
}
